import { Suspense } from 'react';

import { Skeleton } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { ErrorBoundary } from '../../../../errorBoundary/ErrorBoundary';
import { useGetDashboardTitleData } from '../dashboardTitle/useGetDashboardTitleData';

export const LoanTitle = ({ accountId }: { accountId: string }) => {
    return (
        <ErrorBoundary
            fallback={() => (
                <FormattedMessage
                    id="_.modal.fallback_error.label"
                    defaultMessage="Oops, it looks like something went wrong"
                />
            )}
        >
            <Suspense fallback={<Skeleton />}>
                <Title accountId={accountId} />
            </Suspense>
        </ErrorBoundary>
    );
};

const Title = ({ accountId }: { accountId: string }) => {
    const { isRBL, isInterestOnlyLoan, durationInMonths, isTermLoan } =
        useGetDashboardTitleData(accountId);

    if (isRBL) {
        return (
            <FormattedMessage
                id="_.dashboard.rbl_title"
                defaultMessage="Revenue based loan"
            />
        );
    }

    if (isTermLoan) {
        return (
            <FormattedMessage
                id="_.dashboard.term_loan_title"
                defaultMessage="Business loan"
            />
        );
    }

    if (isInterestOnlyLoan) {
        return (
            <FormattedMessage
                id="_.dashboard.interest_only_title"
                defaultMessage="Interest only Flexi-Loan"
            />
        );
    }

    return (
        <>
            {durationInMonths! && durationInMonths <= 6 ? (
                <FormattedMessage
                    id="_.dashboard.micro_loan_title"
                    defaultMessage="{duration} month micro credit"
                    values={{
                        duration: durationInMonths
                    }}
                />
            ) : (
                <FormattedMessage
                    id="_.dashboard.loan_title"
                    defaultMessage="{duration} month Flexi-Loan"
                    values={{
                        duration: durationInMonths
                    }}
                />
            )}
        </>
    );
};
